module.exports = __webpack_public_path__ + "fonts/SourceHanSansSC-Bold-subset.752fa879.woff";